export function addPropertyToWindow<T>(key: string, property: T): void {
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
    (window as any)[key] = property;
  }
}
